// extracted by mini-css-extract-plugin
export default {"inviteCheckbox":"styles_inviteCheckbox__x7xX5","inviteCheckboxLabel":"styles_inviteCheckboxLabel__LKI5S"};